export default __webpack_public_path__ + "static/media/product-01.965e8b75.jpg";